module.exports = __webpack_public_path__ + "riskReturn.054016ad0b2d82912b5233ea2d585ef9.png";